"use client";

import React from "react";
import { X } from "lucide-react";
import { Button } from "../../button";

// Success display component for consistent feedback
interface SuccessDisplayProps {
  message: string;
  onDismiss?: () => void;
  className?: string;
  actionButton?: {
    label: string;
    onClick: () => void;
  };
}

export const SuccessDisplay: React.FC<SuccessDisplayProps> = ({
  message,
  onDismiss,
  className = "",
  actionButton,
}) => {
  return (
    <div
      className={`border-l-4 border-green-500 bg-green-50 dark:bg-green-950/40 p-4 rounded-r-lg shadow-sm ${className}`}
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="h-5 w-5 text-green-600">✓</div>
        </div>
        <div className="ml-3 flex-1">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium text-green-800">{message}</p>
            <div className="flex items-center gap-2">
              {actionButton && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={actionButton.onClick}
                  className="text-xs text-green-700 border-green-300 hover:bg-green-100 dark:text-green-300 dark:border-green-800 dark:hover:bg-green-900/40"
                >
                  {actionButton.label}
                </Button>
              )}
              {onDismiss && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={onDismiss}
                  className="h-6 w-6 p-0 text-green-600 hover:text-green-800 hover:bg-green-100 dark:text-green-400 dark:hover:text-green-200 dark:hover:bg-green-900/40"
                >
                  <X size={14} />
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
